import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// used to create fake backend
import { fakeBackendProvider } from './_helpers';

import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AppComponent } from './app.component';
import { AlertComponent } from './_components';
import { HomeComponent } from './home';
import { FormsModule } from '@angular/forms';;
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MatElementsModule } from './_modules/mat-elements.module';;
import { ErrorComponent } from './_components/error/error.component';
import { FeeDetailsComponent } from './fee-details/fee-details.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";


@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        MatElementsModule,
        BrowserAnimationsModule,
        MatAutocompleteModule
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        ErrorComponent,
        FeeDetailsComponent
,

    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

        // provider used to create fake backend
        fakeBackendProvider
    ],
    bootstrap: [AppComponent]
})
export class AppModule { };
